import type { TypedDocumentNode } from '@base-app/web2'
import { gql } from '@base-app/web2'
import type { Event } from './types'

export const CREATE_EVENT: TypedDocumentNode<
  { createEvent: Event },
  {
    client_id: string
    application_id: string
    title: string
    description?: string | null
    date_start?: string | null
    date_end?: string | null
    label?: string | null
    place?: string | null
    image?: string | null
    observations?: string | null
  }
> = gql`
  mutation CreateEvent(
    $client_id: ID!
    $application_id: ID!
    $title: String!
    $description: String
    $date_start: String
    $date_end: String
    $label: String
    $place: String
    $image: String
    $observations: String
  ) {
    createEvent(
      client_id: $client_id
      application_id: $application_id
      title: $title
      description: $description
      date_start: $date_start
      date_end: $date_end
      label: $label
      place: $place
      image: $image
      observations: $observations
    ) {
      id client_id application_id title description date_start date_end label place image image_low_res observations created_at updated_at
    }
  }
`

export const UPDATE_EVENT: TypedDocumentNode<
  { updateEvent: Event },
  {
    id: string
    title?: string
    description?: string | null
    date_start?: string | null
    date_end?: string | null
    label?: string | null
    place?: string | null
    image?: string | null
    observations?: string | null
  }
> = gql`
  mutation UpdateEvent(
    $id: ID!
    $title: String
    $description: String
    $date_start: String
    $date_end: String
    $label: String
    $place: String
    $image: String
    $observations: String
  ) {
    updateEvent(
      id: $id
      title: $title
      description: $description
      date_start: $date_start
      date_end: $date_end
      label: $label
      place: $place
      image: $image
      observations: $observations
    ) {
      id client_id application_id title description date_start date_end label place image image_low_res observations created_at updated_at
    }
  }
`

export const DELETE_EVENT: TypedDocumentNode<{ deleteEvent: boolean }, { id: string }> = gql`
  mutation DeleteEvent($id: ID!) {
    deleteEvent(id: $id)
  }
`
